module.exports = __webpack_public_path__ + "img/icon-01-medali-pemula-transparent.78da7324.png";